// extracted by mini-css-extract-plugin
export default {"Container":"ResizableTable_Container__TUsyr","HeaderCell":"ResizableTable_HeaderCell__f0E1C","Handle":"ResizableTable_Handle__YQv6o","Resized":"ResizableTable_Resized__dpGJL"};